import { faCopy, faPen, faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { faEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EmailTemplate } from '@spike/email-marketing-model';
import { Dropdown, DropdownContent, DropdownTrigger } from 'components/UI/V3/Dropdown';
import { DropdownItem } from 'components/UI/V3/Dropdown/Item/DropdownItem';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import moment from 'moment-timezone';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import { EmailTemplateEditPath } from 'routes/Paths';
import styles from './EmailTemplatesRow.module.scss';

interface EmailTemplatesRowProps {
    template: EmailTemplate;
    onDuplicateTemplate: (template: EmailTemplate) => void;
    onDeleteTemplate: (template: EmailTemplate) => void;
}

const formatDate = (iso: string): string => {
    if (!iso) return '';
    const m = moment(iso);
    return m.isValid() ? m.format('MMM DD, YYYY [at] hh:mm A') : '';
};

const EmailTemplatesRow: FunctionComponent<EmailTemplatesRowProps> = ({
    template,
    onDuplicateTemplate,
    onDeleteTemplate
}) => {
    const history = useHistory();

    const handleEdit = () => {
        if (typeof template.id !== 'number') return;
        history.push(EmailTemplateEditPath.replace(':id', String(template.id)));
    };

    return (
        <TableRow>
            <TableCell>
                <div className={styles.emailCell}>
                    <div className={styles.thumbnail}>
                        {template.html ? (
                            <iframe
                                className={styles.thumbnailIframe}
                                title={template.name}
                                srcDoc={template.html}
                                sandbox=""
                                scrolling="no"
                            />
                        ) : (
                            <div className={styles.thumbnailPlaceholder} />
                        )}
                    </div>
                    <p className={styles.title}>{template.name}</p>
                </div>
            </TableCell>
            <TableCell>{formatDate(template.createdAt)}</TableCell>
            <TableCell>{formatDate(template.updatedAt)}</TableCell>
            <TableCell isActions>
                <Dropdown>
                    <DropdownTrigger>
                        <button
                            type="button"
                            className={styles.actionsButton}
                        >
                            <FontAwesomeIcon icon={faEllipsis} />
                        </button>
                    </DropdownTrigger>

                    <DropdownContent
                        minWidth={130}
                        align="end"
                    >
                        <DropdownItem
                            leftIcon={faPen}
                            onSelect={handleEdit}
                        >
                            Edit
                        </DropdownItem>
                        <DropdownItem
                            leftIcon={faCopy}
                            onSelect={() => onDuplicateTemplate(template)}
                        >
                            Duplicate
                        </DropdownItem>
                        <DropdownItem
                            leftIcon={faTrashAlt}
                            onSelect={() => onDeleteTemplate(template)}
                        >
                            Delete
                        </DropdownItem>
                    </DropdownContent>
                </Dropdown>
            </TableCell>
        </TableRow>
    );
};

export default EmailTemplatesRow;
